import { format } from 'd3-format';
import i18next from './LocalizedStrings';

export const unit = {
    ko: ['억', '조', '경', '해', '자', '양', '구', '간', '정', '재', '극'],
    jp: ['億', '兆', '京', '垓', '秭', '穰', '溝', '澗', '正', '載', '極',]
}

const _exchangeValue = require('../asset/data/exchangeValue.json')
export var exchangeValue = {}

_exchangeValue.forEach(e => {
    exchangeValue[e.code] = { value: e.value, symbol: e.symbol }
});


export function exchange(value, currency) {
    return value / exchangeValue[currency].value
}

export function getFullCurrencyString(value, displayCurrency) {

    let exchangeRate = exchangeValue[displayCurrency].value || 1
    const exchange = value * exchangeRate

    return exchangeValue[displayCurrency].symbol + format(",.0f")(exchange)
}

export function getShortCurrencyString(value, displayCurrency) {
    const string = getCurrencyString(value, displayCurrency)
    return string.split(' ')[0]
}

export function getCurrencyString(value, displayCurrency) {

    if (displayCurrency === undefined) {
        console.error('displayCurrency is undefined')
    }

    const prefix = value < 0 ? '-' : ''
    value = Math.abs(value)

    let exchangeRate = exchangeValue[displayCurrency].value || 1

    var exchange = value * exchangeRate
    const lang = i18next.getLanguage()

    if (lang === 'ko' || lang === 'ja') {
        let cutValue = Math.round(exchange / 10000000)
        if (cutValue < 1) {
            if (exchange > 100000) {
                cutValue = Math.round(exchange / 10000)
                const surfix = lang == 'ko' ? '만' : '万'
                return prefix + exchangeValue[displayCurrency].symbol + format(",.0f")(cutValue) + surfix
            }

            return prefix + exchangeValue[displayCurrency].symbol + format(",.0f")(exchange)
        }

        const arr = cutValue.toString().split('')
        const lastNum = arr.pop()
        const size = arr.length

        let currencyString = ''
        if (lastNum != '0' && size <= 4) {
            currencyString = lastNum + (lang === 'ko' ? '천만' : '千万')
        }

        const _unit = lang === 'ko' ? unit.ko : unit.jp

        for (var i = 0; i < size; i++) {
            const num = arr.pop()
            if (i % 4 == 0) {
                currencyString = num + _unit[i / 4] + ' ' + currencyString
            } else {
                currencyString = num + currencyString
            }
        }

        return prefix + exchangeValue[displayCurrency].symbol + currencyString
    }

    return commarize(exchange, displayCurrency);
}

export function commarize(value, displayCurrency) {


    const min = min || 1e3;
    // Alter numbers larger than 1k
    if (value >= min) {
        var units = ["K", "M", "B", "t", "q", "Q", "s", "S", "o", "n", "d", "U", "D", "T", "Qt", "Qd", "Sd"];

        var order = Math.floor(Math.log(value) / Math.log(1000));
        var unitname = units[(order - 1)];
        var num = Math.floor(value / 1000 ** order);

        return exchangeValue[displayCurrency].symbol + format(",.0f")(num) + unitname
    }

    return exchangeValue[displayCurrency].symbol + format(",.0f")(value)
}